export const LIST_LOCAIS = 'LIST_LOCAIS';
export const LIST_ULTIMAS = 'LIST_ULTIMAS';
